require('./bootstrap');

require('bootstrap-select/dist/js/bootstrap-select.min');

require('@fortawesome/fontawesome-free/js/all');

require('ekko-lightbox/dist/ekko-lightbox');

$('.heroContainer').css('max-height', (window.innerHeight + "px"));

$(document).ready(function() {

    //ATTIVO BS-SELECT in tutte le select del sito
    $('select').selectpicker();

    //NASCONDO E MOSTRO AL TOGGLE LA SELEZIONE LINGUE
    $(".selectLanguage").hide();

    $(".btnLangSelect").click(function() {
        $(".selectLanguage").slideToggle('slow');
    });
});

// TODO se non usato, non includerlo nelle pagine
$(document).on('click', '[data-toggle="lightbox"]', function(event) {
    event.preventDefault();
    $(this).ekkoLightbox({
        'leftArrow': "<span><i class='fas fa-chevron-left arrowgallery'></i></span>",
        'rightArrow': "<span><i class='fas fa-chevron-right arrowgallery'></i></span>",
    });
});

// solamente in dettaglio tyre      // TODO spostare?
if ($('#technicalDataSelectorMobile').length > 0) {
    $('#technicalDataSelectorMobile').on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue) {
        $('.technicalDataTableMobile').hide();
        $('#mobile_table_'+$(this).val()).show();
    });
    $('#technicalDataSelectorMobile').on('loaded.bs.select', function (e, clickedIndex, isSelected, previousValue) {
        $('.technicalDataTableMobile').hide();
        $('#mobile_table_'+$(this).val()).show();
    });
}

// solamente in dealers
if ($('#map').length > 0) {
    $(function () {
        initMap();
        searchDealers();
    });

    function initMap() {
        // The map, centered at Italy
        const map = new google.maps.Map(document.getElementById("map"), {
            zoom: $('#map').data('zoom'),
            center: { lat: $('#map').data('latitude'), lng: $('#map').data('longitude') },
        });

        $('.card-dealer').each(function()
        {
            let lat = $(this).data('latitude');
            let lng = $(this).data('longitude');

            new google.maps.Marker({
                position: { lat: lat, lng: lng },
                map,
                icon: 'images/marker.png',
            });
        })
    }

    function searchDealers()
    {
        let $form = $('#formSearchDealers');

        if ($form.length > 0)
        {
            $form.on('submit', function(e)
            {
                e.preventDefault();

                let string = $form.find('input').val();

                $('.card-dealer').each(function()
                {
                    let name = $(this).find('h2').text();
                    let address = $(this).find('.search-address').text();

                    (name.toLowerCase().search(string) >= 0 || address.toLowerCase().search(string) >= 0) ? $(this).parent('div').show() : $(this).parent('div').hide();
                })
            });
        }
    }
}
